<!--  -->
<template>
  <div class="bigBox">
    <div class="w1200">
      <div class="row">
        <div class="left">
          <div class="title">我们的客户</div>
          <div class="content">
            客户的积累本质上是行业经验和专业技术的积累,在我们的经营理念中,客户至上是最重要的,我们时刻关注客户需求,提供卓越的产品和服务,实现客户和企业的双赢。
          </div>
        </div>
        <div class="right">
          <img src="@/assets/friend.png" >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  name: "HomeTop",
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  created() {},
};
</script>
<style lang="less" scoped>
.row {
  width: 100%;
  height: 400px;
  display: flex;
  margin-top: 50px;
  .left {
    width: 50%;
    height: 400px;
    .title {
      font-size: 3rem;
      color: #000000;
      font-family: "syhtm";
      margin-bottom: 15px;
    }
    .content {
      height:100px;
      line-height: 36px;
      font-size:16px;
      color: #000000;
      margin-bottom: 15px;
      margin-right: 20px;
    }
  }
  .right {
    width: 50%;
    height: 400px;
    overflow: hidden;
    img{
      display: inline-block;
      width:100%;
      height: 400px;
      cursor: pointer;
      transition: all .6s;
    }
  }
  .right{
    img:hover{
       transform: scale(1.2);
    }
  }
}
</style>